// extracted by mini-css-extract-plugin
export default {"container":"viewMenu_container__8gejA"};